import { useEffect, useState } from 'react';
import api from '../../services/api';
import useWrapper from '../useWrapper';

const useSuppliers = (props = {}) => {
  const { query = "?" } = props;
  const { config } = useWrapper();

  const [load, setload] = useState(false);
  const [reload, setreload] = useState();
  const [suppliers, setsuppliers] = useState();
  useEffect(() => {
    if(load) {
      (async () => {
        try {
          const { data : _suppliers} = await api.get(`providers${query}`, config);
          setsuppliers(_suppliers);
        }
        catch(__err) {
          console.log('__err', __err);
        }
      })()
    }
  }, [reload, load]);

  const reloadPage = () => { setreload(!reload) }
  const loadPage = () => { setload(true); }

  return {
    data: suppliers,
    load: loadPage,
    reload: reloadPage
  };
}

export default useSuppliers;